import type React from "react";

interface CognitoProps {
  paymentId: string;
  plan: string;
}

const CognitoFormEmbed: React.FC<CognitoProps> = ({ paymentId, plan }) => {
  const entry = encodeURIComponent(
    JSON.stringify({
      PaymentId: paymentId,
      Type: plan === "クレジット購入" ? "クレジット追加" : "プラン変更",
      ...(plan === "クレジット購入"
        ? {}
        : {
            Changeplansection: {
              Newplan: plan,
            },
          }),
    }),
  );

  const formUrl = `https://www.cognitoforms.com/Kintoneプラグイン/レクシンAI各種手続きフォーム?entry=${entry}`;

  return (
    <iframe
      src={formUrl}
      style={{ width: "100%", height: "100%", border: "none" }}
      title={`Cognito Form - ${plan}`}
    />
  );
};

export default CognitoFormEmbed;
